import { render, staticRenderFns } from "./AdminRegisterLayoutIframe.vue?vue&type=template&id=0ce31912&"
import script from "./AdminRegisterLayoutIframe.vue?vue&type=script&lang=ts&"
export * from "./AdminRegisterLayoutIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports